import { render } from "./Add.vue?vue&type=template&id=20cb1459&scoped=true"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"

import "./Add.vue?vue&type=style&index=0&id=20cb1459&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-20cb1459"

export default script